module.exports = __webpack_public_path__ + "static/media/hot_jdylc.cc5a7f75.png";